import { ChangeEvent } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import TextField from '@material-ui/core/TextField';

import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

export const dependentEnvBranchInputSchema = makeFieldSchema({
  output: z => z.string(),
  uiOptions: z =>
    z.object({
      dependsOn: z
        .string()
        .optional()
        .describe(
          'The field name in the form data to depend on, defaults to "team"',
        ),
    }),
});

const envBranchPattern = (isEteSupport: boolean): RegExp =>
  isEteSupport ? /^[dt][0-9]$/ : /^([dt][0-9]|p[0-4](-(active|hidden))?)$/;

export const dependentEnvBranchInputValidation = (
  value: string,
  validation: any,
  context: any,
) => {
  const options = context.uiSchema?.['ui:options'] || {};
  const dependsOnField = (options.dependsOn as string) || 'team';

  const dependencyRef = (context.formData?.[dependsOnField] as string) || '';
  const dependencyName = dependencyRef.split('/').pop() || '';

  const isEteSupport = dependencyName === 'ete-supports';
  const pattern = envBranchPattern(isEteSupport);

  if (value && !pattern.test(value)) {
    validation.addError(`Must match pattern ${pattern.toString()}`);
  }
};

export const DependentEnvBranchInput = ({
  formData,
  onChange,
  formContext,
  rawErrors,
  uiSchema,
  idSchema,
  schema,
  required,
}: FieldExtensionComponentProps<string>) => {
  // Read the dependent field name from yaml ui:options
  const options = uiSchema?.['ui:options'] || {};
  const dependsOnField = (options.dependsOn as string) || 'team';

  // Read the value of the dependent field from form data
  const dependencyRef = formContext.formData[dependsOnField] || ''; // e.g. group:namespace/ete-support
  const dependencyName = dependencyRef.split('/').pop() || '';

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  // Determine valid pattern dynamically
  const isEteSupport = dependencyName === 'ete-supports';
  const pattern = envBranchPattern(isEteSupport);
  const helpText = isEteSupport
    ? 'The environment branch e.g., d0,t0 (ete-supports cannot start with p)'
    : 'The environment branch e.g., d0, t0, p0. A prod LAMBDA may append the ' +
      'side: p0-hidden (standby, same as p0) or p0-active (live now).';

  const isValid = !formData || pattern.test(formData);
  const isError = !isValid || (rawErrors && rawErrors.length > 0);

  return (
    <TextField
      id={idSchema?.$id}
      value={formData || ''}
      onChange={handleChange}
      error={isError}
      helperText={helpText}
      FormHelperTextProps={{ style: { marginLeft: 0 } }}
      fullWidth
      margin="normal"
      variant="outlined"
      label={schema?.title || 'Environment Branch'}
      required={required}
    />
  );
};
